<ng-template
  #labelTemplate
  let-clear="clear"
  let-items="items"
  ng-multi-label-tmp>
  @for (item of items; track $index) {
    <div class="ng-value me-2">
      <bn-web-ui-badge
        color="blue"
        size="sm"
        type="tag">
        <span>{{ item }}</span>
        <fa-icon
          aria-hidden="true"
          class="cursor-pointer"
          icon="xmark"
          (click)="clear(item)" />
      </bn-web-ui-badge>
    </div>
  }
</ng-template>
